import React, {PropTypes} from 'react';
import {Link} from 'react-router';
import {I18n} from 'react-redux-i18n';

const UserTableRow = ({
	onSelected,
	user
}) => {
	return (
		<tr onClick={() => {onSelected(user);}}>
      <td>{`${user.firstName} ${user.lastName}`}</td>
      <td>{user.isActive ? I18n.t('ACTIVE') : I18n.t('INACTIVE')}</td>
      <td><Link to="/users/edit">{I18n.t('EDIT')}</Link></td>
    </tr>
	);
};

UserTableRow.propTypes = {
	onSelected: PropTypes.func.isRequired,
	user: PropTypes.object.isRequired
};

export default UserTableRow;


/** WEBPACK FOOTER **
 ** ./src/modules/users/components/UserTableRow.js
 **/